module.exports = __webpack_public_path__ + "img/Pecan-Hollow.3077ad77.jpeg";